import './interceptors'
import $http from 'axios'
require('promise.prototype.finally').shim()


export default {
    $http: $http,
    pt: require('./pt').default($http),
    wx: require('./wx').default($http)
}


// WEBPACK FOOTER //
// ./src/api/index.js